// extracted by mini-css-extract-plugin
export default {"sliderButtonsCont":"SliderButtonsSet_sliderButtonsCont__fPHti","activeBtn":"SliderButtonsSet_activeBtn__sMHSx"};